export default __webpack_public_path__ + "static/media/New.c178c825.svg";